export const getStatusLabel = (status: string): string => {
  if (status === "Campaign") {
    return "In Execution";
  } else if (status === "Brief") {
    return "In Brief";
  } else if (status === "Closed") {
    return "Closed";
  }
  return status;
};